import { PropsWithChildren } from 'react';
import { ExerciseModuleContextProvider } from '../../_contexts/ExerciseModuleContext';
import { MedialinksContextProvider } from './MedialinksContext';
import { PinnedMaterialContextProvider } from './PinnedMaterialContext';
import { SelectionContextProvider } from './SelectionContext';
import { SharedMaterialsContextProvider } from './SharedMaterialsContext';
import { SlideSetsContextProvider } from './SlideSetsContext';
import { UserMaterialContextProvider } from './UserMaterialContext';

export default function TocDataProvider({ children }: PropsWithChildren) {
  return (
    <SharedMaterialsContextProvider>
      <MedialinksContextProvider>
        <UserMaterialContextProvider>
          <SlideSetsContextProvider>
            <SelectionContextProvider>
              <ExerciseModuleContextProvider>
                <PinnedMaterialContextProvider>{children}</PinnedMaterialContextProvider>
              </ExerciseModuleContextProvider>
            </SelectionContextProvider>
          </SlideSetsContextProvider>
        </UserMaterialContextProvider>
      </MedialinksContextProvider>
    </SharedMaterialsContextProvider>
  );
}
